import { AffiliationBoardPosition } from 'generated/graphql';

const boardPositions: Record<string, AffiliationBoardPosition> = {
  Director: AffiliationBoardPosition.Director,
  Member: AffiliationBoardPosition.Member,
  President: AffiliationBoardPosition.President,
  Secretary: AffiliationBoardPosition.Secretary,
  VicePresident: AffiliationBoardPosition.VicePresident,
};

export const getBoardPositionEnum = (type: string): AffiliationBoardPosition | undefined => {
  if (!type) {
    return undefined;
  }

  return type in boardPositions ? boardPositions[type] : (type as AffiliationBoardPosition);
};
